import React from 'react';

// Renders text with "\n" as line breaks.
export const Br = ({ text }) => text.split('\n').map((l, i, a) => (
    <React.Fragment key={i}>{l}{i < a.length - 1 && <br />}</React.Fragment>
));

export default Br;
